export const fontNames=['Arial','Brush Script MT','Indie Flower','Josefin Slab Thin','Lobster','IBM Plex Sans'];